import FirstPageIcon from '@mui/icons-material/FirstPage';
import NavigateNextOutlinedIcon from '@mui/icons-material/NavigateNextOutlined';
import styled from 'styled-components';
import { media } from '@/styles/responsive';

export const SimpleArrowIcon = styled(NavigateNextOutlinedIcon)`
  color: ${(props) => props.theme.colors['neutral-100']};
`;

export const BarArrowIcon = styled(FirstPageIcon)`
  color: ${(props) => props.theme.colors['neutral-100']};
`;

export const Box = styled.div`
  display: flex;
  margin-top: 27px;
  justify-content: end;
  align-items: center;
  flex-direction: column;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: row;
    justify-content: space-between;
  }

  ul {
    display: flex;
  }

  li.rc-pagination-item-active button {
    color: red;
    font-weight: 700;
    color: ${(props) => props.theme.colors['primary-60']};

    &:after {
      content: '';
      width: 5px;
      height: 5px;
      background: ${(props) => props.theme.colors['primary-60']};
      position: absolute;
      bottom: 0;
      left: 0;
      border-radius: 50%;
      right: 0;
      margin: auto;
    }
  }

  svg {
    font-size: 14px;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: row;
  }
`;

export const CountLabel = styled.p`
  color: ${(props) => props.theme.colors['neutral-100']};
`;

export const CountTotal = styled.p`
  margin-left: 6px;
  color: ${(props) => props.theme.colors['neutral-100']};
  font-weight: 600;
`;

export const PaginationButton = styled.button<{ isRotated?: boolean }>`
  position: relative;
  color: ${(props) => props.theme.colors['neutral-100']};
  padding: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  line-height: 16px;
  border-radius: 8px;
  min-width: 36px;
  min-height: 36px;
  transition: background-color 200ms cubic-bezier(0.2, 0.8, 0.4, 1);
  -webkit-tap-highlight-color: transparent;

  &:hover:not(:disabled) {
    background-color: ${(props) => props.theme.colors['neutral-20']};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  svg {
    transform: ${({ isRotated }) => `rotate(${isRotated ? '180deg' : '0'} )`};
  }

  ${media.mobile} {
    min-width: 44px;
    min-height: 44px;
  }
`;

export const DropdownArea = styled.div`
  display: flex;
  margin-top: 10px;

  & > div {
    max-width: 100%;
    margin-bottom: 0;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-top: 0;

    #dropdown-area .dropdown-is-closed > div {
      inset: 0px auto auto -75px !important;
    }
  }
`;
